<div [formGroup]="parent" [ngClass]="[((parent.get(controlName).touched
    && parent.get(controlName).errors)?'has-error':''),
    (componentName === 'yourOptions')?'form-field form-field-margin-0':
    ((componentName === 'yourPesionSavings')?'form-field form-field-apply':'form-field'),
    (parent.get(controlName).touched && parent.get(controlName).errors && componentName === 'yourOptions')? 'margin-top-30':'']">
    <span [ngClass]="{'font-color-red': parent.get(controlName).errors 
    && parent.get(controlName).touched
    && (parent.get(controlName).errors.required || parent.get(controlName).errors.invalidMaturity)}"
  class="currency-symbol" id="currency-symbol">%</span>
  <label [id]="'lbl-'+controllerData['name']" class="visuallyhidden">{{controllerData['name']}}</label>
  <input class="form-control form-width" appCurrency DecimalPlaces="2" [attr.aria-required]="true" [attr.aria-invalid] = "(parent.get(controlName).errors
    && parent.get(controlName).touched
    && (parent.get(controlName).errors.required || parent.get(controlName).errors.invalidMaturity)) ? true : false"  aria-label="currency field" [minValue]="0" [maxValue]="99.99"
    [formControlName]="controlName" [id]="controllerData['name']" [(ngModel)]="controllerData.currentValue" [name]="controllerData['name']"
    [placeholder]="" autocomplete="off" (input)="currencyChangeHandler($event.target.value)"
    (keyup.enter)="validateInput()" (blur)="validateInput()">
    <i  class="currency-text" [id]="controllerData['name']+'-value'" >Price: {{calculateTFCAmount() | currency:'GBP'}}</i>
    @if (controllerData.infoIconFlag) {
      <app-tool-tip-notification [childId]="sliderId" [tooltipName]="controlName+'_tooltip'"
      class="col-sm-1 info-icon" [tooltipData]="controllerData.infoIconData"></app-tool-tip-notification>
    }
  </div>
  @if (parent.get(controlName).touched && parent.get(controlName).errors) {
    <div [id]="controlName+'-error'" class="form-validation-error" 
>
      <i class="icon icon-error" aria-hidden="true"></i>
      @if (parent.get(controlName).errors.notValid) {
        <p id="currency-error" aria-hidden="false" role="error">{{controllerData['validationMsg']}}</p>
      }
      @if (parent.get(controlName).errors.invalidMaturity) {
        <p id="currency-error" aria-hidden="false" role="error">{{controllerData['customErrorMessage1']}}</p>
      }
      @if (parent.get(controlName).errors.invalidTaxfree) {
        <p id="currency-error" aria-hidden="false" role="error">{{invalidTaxfree(controllerData.invalidTaxfreeMessage)}}</p>
      }
      @if (parent.get(controlName).errors.invalidLTAMin) {
        <p id="currency-error" aria-hidden="false" role="error">{{setMinLTA(controllerData.invalidLTAMinMsg)}}</p>
      }
    </div>
  }
